
const isNseAnnouncement = (a) => (a?.exchange || '').toString().toUpperCase() === 'NSE';

const getAnnouncementMessageForKey = (a) => {
    if (!a) return '';
    // Use Details for NSE announcements, message for others
    return isNseAnnouncement(a) ? (a.Details ?? a.details ?? '') : (a.message ?? '');
};


export const setGridItemHeight = (newHeight, setLayouts, itemIndex) => {
    setLayouts((prevLayouts) => {
        const currentLayout = prevLayouts[itemIndex];
        if (!currentLayout) return prevLayouts;

        const currentHeight = currentLayout.h;
        if (currentHeight === newHeight) return prevLayouts;

        const updatedLayouts = [...prevLayouts];
        updatedLayouts[itemIndex] = {
            ...currentLayout,
            h: newHeight,
        };

        console.log("updatedLayouts returned");
        return updatedLayouts;
    });
};

export const handleShowAnnouncementsPF = async (
    instrumentEntity,
    setAggregatedSortedStocksCurrentClientTab,
    setLayouts,
    tabID,
    layouts,
    itemIndex,
    announcements = [],
    newAnnouncements = [],
    setIsUnmounting,
    listRef
) => {

    if (instrumentEntity.forceShowAnnouncements) {
        setIsUnmounting(true);
        setGridItemHeight(1, setLayouts, itemIndex);

        setAggregatedSortedStocksCurrentClientTab(prev =>
            prev.map(stock =>
                stock.instrumentEntity.instrumentToken === instrumentEntity.instrumentToken
                    ? {
                        ...stock,
                        instrumentEntity: {
                            ...stock.instrumentEntity,
                            forceShowAnnouncements: false
                        }
                    }
                    : stock
            )
        );

    } else{
        setIsUnmounting(false);
        setAggregatedSortedStocksCurrentClientTab(prev =>
            prev.map(stock =>
                stock.instrumentEntity.instrumentToken === instrumentEntity.instrumentToken
                    ? {
                        ...stock,
                        instrumentEntity: {
                            ...stock.instrumentEntity,
                            forceShowAnnouncements: true
                        }
                    }
                    : stock
            )
        );
        /*const estimatedInitialHeight = Math.min(8.2, (announcements.length || 1) * 1.5); // fallback to 8.2 max

        setLayouts(prev =>
            prev.map((layout, i) =>
                i === itemIndex ? { ...layout, h: estimatedInitialHeight } : layout
            )
        );

        if (listRef?.current) {
            listRef.current.resetAfterIndex(itemIndex, false);
        }*/

    }
};

// AnnouncementTimeUtil.js
export const parseBroadcastTime = (s) => {
    if (!s) return 0;
    const str = s.toString().trim();

    // BSE: 11-12-2025 09:29:08
    let m = /^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})$/.exec(str);
    if (m) {
        const [, dd, mm, yyyy, HH, MM, SS] = m;
        return Date.UTC(+yyyy, +mm - 1, +dd, +HH, +MM, +SS);
    }

    // NSE: 12-Dec-2025 13:04:54
    m = /^(\d{2})-([A-Za-z]{3})-(\d{4}) (\d{2}):(\d{2}):(\d{2})$/.exec(str);
    if (m) {
        const [, dd, monStr, yyyy, HH, MM, SS] = m;
        const mon = ({jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11})[monStr.toLowerCase()];
        if (mon === undefined) return 0;
        return Date.UTC(+yyyy, mon, +dd, +HH, +MM, +SS);
    }

    return 0;
};

export const handleShowAnnouncementsMW = async (
    GUIInstrument,
    setGUIInstruments,
    setLayouts,
    tabID,
    layouts,
    itemIndex,
    announcements = [],
    newAnnouncements = [],
    setIsUnmounting
) => {

    if (GUIInstrument.forceShowAnnouncements) {
        setIsUnmounting(true);
        setGridItemHeight(1, setLayouts, itemIndex);

        setGUIInstruments(prev =>
            prev.map(instr =>
                instr.instrumentToken === GUIInstrument.instrumentToken
                    ? { ...instr, forceShowAnnouncements: false }
                    : instr
            )
        );
    } else{
        setIsUnmounting(false);
        setGUIInstruments(prev =>
            prev.map(instr =>
                instr.instrumentToken === GUIInstrument.instrumentToken
                    ? { ...instr, forceShowAnnouncements: true }
                    : instr
            )
        );
    }
};